import { createSlice } from "@reduxjs/toolkit";
import { getUserInvites, getContestants } from "./ReferralActions";

const initialState = {
    loading: false,
    invites: [], // for machines array
    contestants: [],
    error: null,
    success: false, // for monitoring the registration process.
  }

const referralSlice = createSlice({
    name: "invites",
    initialState,
    reducers: {},
    extraReducers:{
        [getUserInvites.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
            state.invites = payload.data
        },
        [getUserInvites.pending]: (state, {payload}) => {
            state.loading = true
        },
        [getUserInvites.rejected]: (state, {payload}) => {
            state.loading = false
            state.invites = payload
        },
        [getContestants.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
            state.contestants = payload.data
        },
        [getContestants.pending]: (state, {payload}) => {
            state.loading = true
        },
        [getContestants.rejected]: (state, {payload}) => {
            state.loading = false
            state.contestants = payload
        }
    }
})

export default referralSlice.reducer